<template>
  <div>
    <div class="header-bc">
      <div class="content">
        <div class="label clearfix">
          <div class="title">手机号</div>
          <div class="input">
            <input type="text" placeholder="请输入手机号码" v-model="accountData.MobilePhone">
          </div>
        </div>
        <div class="label clearfix">
          <div class="title">验证码</div>
          <div class="input">
            <input type="text" placeholder="请输入验证码" v-model="accountData.Captcha">
            <button class="btn-code" @click="onCode" :disabled="disabled">{{btntxt}}</button>
          </div>
        </div>
        <div class="label clearfix mat-10">
          <div class="title">登录密码</div>
          <div class="input">
            <input type="password" placeholder="请输入密码" v-model="accountData.Password">
          </div>
        </div>
        <div class="label clearfix mat-10">
          <div class="title">确认密码</div>
          <div class="input">
            <input type="password" placeholder="请确认密码" v-model="accountData.ConfirmPassword">
          </div>
        </div>
        <button class="btn-main btn-account" @click="onLogin">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      btntxt: '获取验证码',
      accountData: {
        MobilePhone: '',
        Password: '',
        ConfirmPassword: '',
        Captcha: ''
      },
      codeData: {
        phone: '',
        typeCode: 1002
      }
    }
  },
  methods: {
    timer() {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后重新获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.disabled = false
      }
    },
    onCode() {
      this.codeData.phone = this.accountData.MobilePhone
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      if (this.codeData.phone === '') {
        this.$dialog.toast({
          mes: '请输入手机号码',
          timeout: 1500,
          icon: 'loding'
        })
        return
      } else if (!reg.test(this.codeData.phone)) {
        this.$dialog.toast({
          mes: '请输入正确的手机号',
          timeout: 1500
        })
      } else {
        this.time = 60
        this.disabled = true

        this.$fetch('/api/Account/GetMobileCode', this.codeData)
          .then(result => {
            this.timer()
          })
          .catch(result => {
            this.$dialog.toast({
              mes: result.Error.Message,
              timeout: 2500
            })
          })
      }
    },
    onLogin() {
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      if (this.accountData.MobilePhone === '') {
        this.$dialog.toast({
          mes: '请输入手机号码',
          timeout: 1500
        })
        return
      } else if (!reg.test(this.accountData.MobilePhone)) {
        this.$dialog.toast({
          mes: '请输入正确的手机号',
          timeout: 1500
        })
        return
      } else if (this.accountData.Captcha === '') {
        this.$dialog.toast({
          mes: '请输入验证码',
          timeout: 1500
        })
        return
      } else if (this.accountData.Password === '') {
        this.$dialog.toast({
          mes: '请输入密码',
          timeout: 1500
        })
        return
      } else if (this.accountData.Password.length < 6) {
        this.$dialog.toast({
          mes: '密码至少6位数',
          timeout: 1500
        })
        return
      } else if (this.accountData.ConfirmPassword === '') {
        this.$dialog.toast({
          mes: '请再次输入密码',
          timeout: 1500
        })
        return
      } else if (this.accountData.Password !== this.accountData.ConfirmPassword) {
        this.$dialog.toast({
          mes: '两次密码不一致',
          timeout: 1500
        })
        return
      } else {
        this.$post('/api/Account/ResetPasswordSave', this.accountData)
          .then(result => {
            this.$dialog.toast({
              mes: '密码重置成功！',
              timeout: 1500,
              icon: 'success'
            })
            this.$router.push({
              path: '/account/login'
            })
          })
          .catch(result => {
            this.$dialog.toast({
              mes: result.Error.Message,
              timeout: 2500
            })
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header-bc {
  width: 100%;
  // height: 690/@rem-size;
  background: url('../../assets/images/account-bc.png');
  background-size: 100% 100%;
  padding-top: 178 / @rem-size;

  .content {
    width: 640 / @rem-size;
    height: auto;
    background: #fff;
    margin: 0 auto;
    border-radius: 8 / @rem-size;
    padding: 52 / @rem-size 30 / @rem-size 100 / @rem-size;
  }

  .label {
    width: 100%;
    height: 89 / @rem-size;

    .title {
      float: left;
      line-height: 89 / @rem-size;
      width: 120 / @rem-size;
      text-align: right;
      font-size: 28 / @rem-size;
      color: #333;
    }

    .input {
      width: 430 / @rem-size;
      height: 89 / @rem-size;
      float: right;
      border-bottom: 1px solid #e5e5e5;
      position: relative;

      .btn-code {
        min-width: 120 / @rem-size;
        height: 64 / @rem-size;
        position: absolute;
        bottom: 10 / @rem-size;
        right: 0;
        background: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 8 / @rem-size;
        padding: 0 15 / @rem-size;
      }

      input {
        width: 100%;
        height: 100%;
        font-size: 28 / @rem-size;
        padding-left: 10 / @rem-size;
      }
    }
  }
}

.mat-10 {
  margin-top: 10 / @rem-size;
}

.btn-account {
  width: 100%;
  height: 80 / @rem-size;
  font-size: 36 / @rem-size;
  border-radius: 8 / @rem-size;
  margin-top: 57 / @rem-size;
}

.hint-message {
  margin-top: 28 / @rem-size;

  div {
    a {
      font-size: 28 / @rem-size;
      color: #999;
    }
  }
}
</style>
